export const buildService = {
  isProduction: 'production' === process.env.NODE_ENV,
  isDevelopment: 'development' === process.env.NODE_ENV,
  isTest: 'test' === process.env.NODE_ENV
};
